import category from '../objects/category/index';

// run all related funcs here
category();
